export function imageFrameStyle(frame) {
    const number = (value, fallback, min, max) => Number.isFinite(Number(value)) ? Math.max(min, Math.min(max, Number(value))) : fallback;
    const x = number(frame?.x ?? 50, 50, 0, 100);
    const y = number(frame?.y ?? 50, 50, 0, 100);
    const zoom = number(frame?.zoom ?? 1, 1, 1, 2);
    return { objectPosition: `${x}% ${y}%`, transform: `scale(${zoom})`, transformOrigin: `${x}% ${y}%` };
}

export const FRAME_RATIOS = { '4:3': '4 / 3', '16:9': '16 / 9', '3:4': '3 / 4', '2:3': '2 / 3', '1:1': '1 / 1' };
export const imageFrameBox = (frame, fallback = '4:3') => ({ aspectRatio: FRAME_RATIOS[frame?.ratio] || FRAME_RATIOS[fallback] });
